"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.italic = void 0;
var FontData_js_1 = require("../../FontData.js");
var italic_js_1 = require("../../../common/fonts/tex/italic.js");
exports.italic = (0, FontData_js_1.AddCSS)(italic_js_1.italic, {
    0x2F: { f: 'I' },
    0x3DD: { c: '\\E008', f: 'A' },
    0x2015: { c: '\\2014' },
    0x2017: { c: '_' },
    0x2044: { c: '/', f: 'I' },
    0x2206: { c: '\\394', f: 'I' },
    0x29F8: { c: '/', f: 'I' },
});
//# sourceMappingURL=italic.js.map